<template>
    <transition name="toast" v-on:leave="leave">
        <div class="toast-layer" v-show="isShow">
            <div class="toast-box">
                <div class="toast-txt">
                    <img v-bind:src="icon" v-if="icon !== 'none'">
                    <span>{{text}}</span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Toast",
        data() {
            return {
                text: '',
                icon: 'none',
                isShow: false,
            }
        },
        methods: {
            leave(el, done) {
                setTimeout(done, 200)
            },
            show(title, onHide, timeout = 1200, icon) {
                if (!title) return;
                this.text = title;
                if (icon) this.icon = icon;
                this.isShow = true;
                setTimeout(() => {
                    this.hide();
                    onHide && onHide();
                }, timeout);
            },
            hide() {
                this.isShow = false;
                this.icon = 'none'
            }
        },

    }
</script>
<style lang="scss" rel="stylesheet/scss">

    @import "./src/scss/base/mixins.scss";

    .toast-layer{
        align-items:center;
        position:fixed;
        justify-content:center;
        left:0;
        top:0;
        bottom:0;
        right:0;
        width:100%;
        height:100%;
        z-index:50000;
        display:flex;
    }

    .toast-box{
        background-color:rgba(0, 0, 0, 0.7);;
        border-radius:px2(10);
        -webkit-border-radius:px2(10);
        padding:px2(30);
        margin-top:0;
        transition:all linear .3s;
    }

    .toast-txt{
        font-size:px2(28);
        line-height:1.5;
        text-align:center;
        word-break:break-all;
        color:#fff;
        img{
            display:block;
            margin:0 auto;
            width:px2(80);
            height:px2(80);
        }
    }

    .toast-leave-active .toast-box{
        transition:all linear .2s;
    }

    .toast-leave-to .toast-box{
        transform:translateY(100%);
        opacity:.2;
    }
</style>



// WEBPACK FOOTER //
// src/components/toast/Toast.vue